import { render } from "./DonationGroupManageListPage.vue?vue&type=template&id=f86659b8&lang=true"
import script from "./DonationGroupManageListPage.vue?vue&type=script&lang=js"
export * from "./DonationGroupManageListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__